import React from 'react';
import styled from 'styled-components';
import { Icon } from '@tviklax/ui-components';

const Card = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: ${props => props.theme.shadows.md};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
`;

const Title = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  color: ${props => props.theme.colors.gray800};
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid ${props => props.theme.colors.gray100};

  &:last-child {
    border-bottom: none;
    padding-top: 16px;
    margin-top: 4px;
  }
`;

const Label = styled.span`
  font-size: 0.875rem;
  color: ${props => props.theme.colors.gray500};
  font-weight: 500;
`;

const Value = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: ${props => props.theme.colors.gray800};
  font-variant-numeric: tabular-nums;
`;

const MarginValue = styled.span`
  font-size: 1.25rem;
  font-weight: 700;
  color: ${props => props.theme.colors.success};
  font-variant-numeric: tabular-nums;
`;

interface CostMarginCardProps {
  revenue: string;
  shippingCost: string;
  margin: string;
  avgCostPerShipment: string;
}

export const CostMarginCard: React.FC<CostMarginCardProps> = ({ revenue, shippingCost, margin, avgCostPerShipment }) => {
  return (
    <Card>
      <Header>
        <Icon name="DollarSign" color="#3b82f6" size={20} />
        <Title>Cost & Profit Intelligence</Title>
      </Header>
      <div>
        <InfoRow>
          <Label>Revenue</Label>
          <Value>{revenue}</Value>
        </InfoRow>
        <InfoRow>
          <Label>Total Shipping Cost</Label>
          <Value>{shippingCost}</Value>
        </InfoRow>
        <InfoRow>
          <Label>Avg Cost / Shipment</Label>
          <Value>{avgCostPerShipment}</Value>
        </InfoRow>
        <InfoRow>
          <Label style={{ fontWeight: 700, color: '#1e293b' }}>Gross Margin %</Label>
          <MarginValue>{margin}</MarginValue>
        </InfoRow>
      </div>
      <div style={{ marginTop: '24px', paddingTop: '12px', borderTop: '1px solid #f1f5f9', textAlign: 'right' }}>
        <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>
          Data as of {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
        </span>
      </div>
    </Card>
  );
};
